<template>
  <RevStickyBar
    class="block md:hidden [@media(max-height:512px)]:hidden"
    :visible="showBar"
  >
    <div class="flex items-center">
      <div class="min-w-0 grow">
        <div class="text-static-default-hi heading-2">
          {{ i18n.price(price, { maximumFractionDigits: 0 }) }}
        </div>
        <div class="text-static-default-hi body-2">
          {{ i18n(translations.giftCardPrice) }}
        </div>
      </div>
      <RevButton
        class="ml-12 grow"
        data-qa="gift-cards-buy-button-sticky-bar"
        :loading
        type="submit"
        variant="primary"
      >
        {{ i18n(translations.checkout) }}
      </RevButton>
    </div>
  </RevStickyBar>
</template>

<script lang="ts" setup>
import type { Price as PriceType } from '@backmarket/http-api/src/api-models/Price'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevButton } from '@ds/components/Button'
import { RevStickyBar } from '@ds/components/StickyBar'

import translations from './StickyBarBottom.translations'

const i18n = useI18n()

defineProps<{
  price: PriceType
  showBar: boolean
  loading: boolean
}>()
</script>
